import type { PortalChatMessage } from 'types/aiChat';
import type { FigureDefinition } from 'types/aiChatFigure';
import type { TableFileFormat } from '../../../utils/tableExport';
import { BriefFigure } from './BriefFigure';
import { ChartFigure } from './ChartFigure';
import { DraftFigure } from './DraftFigure';
import { FindingsFigure } from './FindingsFigure';
import { PartyFigure } from './PartyFigure';
import { RecordFigure } from './RecordFigure';
import { RowsFigure } from './RowsFigure';

interface Props {
    definition: FigureDefinition;
    /** The file the user asked for with the file marker after this Figure's own. */
    fileFormat?: TableFileFormat;
    /** The answer the Figure is in: a brief reads its stored brief, its date and its streamed summaries from it. */
    message?: PortalChatMessage;
}

/** A Figure of an answer, drawn by its kind. */
export default function FigurePart({ definition, fileFormat, message }: Props) {
    switch (definition.kind) {
        case 'table':
        case 'list':
            return <RowsFigure definition={definition} fileFormat={fileFormat} />;
        case 'chart':
            return <ChartFigure definition={definition} />;
        case 'brief':
            return message ? <BriefFigure message={message} /> : null;
        case 'findings':
            return <FindingsFigure definition={definition} />;
        case 'draft':
            return <DraftFigure definition={definition} />;
        case 'record':
            return <RecordFigure definition={definition} />;
        case 'party360':
            return <PartyFigure definition={definition} />;
        default:
            return null;
    }
}
